import useServerAuth from '../services/useServerAuth';

/**
 * Auth Hook — Delegiert komplett an useServerAuth (JWT-basiert)
 * 
 * Der `auth` Parameter wird aus Kompatibilitätsgründen akzeptiert,
 * aber ignoriert. Authentifizierung läuft über eigenen Server.
 * 
 * @param {Object} [auth] - Ignoriert (Kompatibilität)
 * @param {Function} [onAuthStateChange] - Callback wenn Auth-State sich ändert
 * @param {Function} [onLoginSuccess] - Callback bei erfolgreichem Login
 * @returns {Object} { currentUser, authLoading, authError, handleGoogleSignIn, handleLogout, ... }
 */
function useAuthentication(auth, onAuthStateChange, onLoginSuccess) {
  return useServerAuth(onAuthStateChange, onLoginSuccess);
}

export default useAuthentication;
